import { ImageIcon } from "assets/icons";
import cn from "classnames";

import { shortId } from "../../helpers";

import styles from "./MediaStrip.module.scss";

export type MediaStripVariant = "neutral" | "added" | "removed";

interface MediaStripProps {
  ids: string[];
  urlById: Map<string, string>;
  variant?: MediaStripVariant;
}

const MediaStrip = ({ ids, urlById, variant = "neutral" }: MediaStripProps) => {
  if (!ids.length) {
    return <span className={styles.empty}>—</span>;
  }

  return (
    <div className={styles.strip}>
      {ids.map((id, index) => {
        const url = urlById.get(id);

        return (
          <div
            key={`${id}-${index}`}
            className={cn(styles.thumb, styles[`thumb--${variant}`])}
            title={shortId(id)}
          >
            {url ? (
              <img
                className={styles.thumb__img}
                src={url}
                alt=""
                loading="lazy"
              />
            ) : (
              <span className={styles.thumb__missing}>
                <ImageIcon />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MediaStrip;
